(function () {
  /* Vergelijking van uitvoeringen: kolom kiezen, tekst bijwerken en de bijbehorende kaartjes markeren. De kaartjes worden pas gemarkeerd nadat iemand een kolom heeft aangeklikt. */
  if (window.__swCompare) return;
  window.__swCompare = true;

  function variantKey(text) {
    var s = (text || '').trim().toLowerCase();
    var i = s.lastIndexOf(' - ');
    return i > -1 ? s.slice(i + 3).trim() : s;
  }

  function update(root, mark) {
    var sel = root.getAttribute('data-selected');
    var name = '';
    root.querySelectorAll('[data-cmp-pick]').forEach(function (btn) {
      var on = btn.getAttribute('data-cmp-pick') === sel;
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      if (on) name = btn.getAttribute('data-name') || btn.textContent.trim();
    });
    root.querySelectorAll('[data-cmp-name]').forEach(function (el) { el.textContent = name; });
    var cta = root.querySelector('[data-cmp-cta]');
    if (cta) cta.textContent = (root.getAttribute('data-cta') || '[naam]').replace('[naam]', name);
    var wanted = name.trim().toLowerCase();
    document.querySelectorAll('.sw-var').forEach(function (card) {
      var title = card.querySelector('.sw-var__name');
      var match = !!mark && !!title && variantKey(title.textContent) === wanted;
      card.classList.toggle('sw-var--match', match);
    });
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;
    var btn = target.closest('[data-cmp-pick]');
    if (!btn) return;
    var root = btn.closest('[data-sw-cmp]');
    if (!root) return;
    root.setAttribute('data-selected', btn.getAttribute('data-cmp-pick'));
    update(root, true);
  });

  function init() { document.querySelectorAll('[data-sw-cmp]').forEach(function (root) { update(root, false); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
